export const MobileChartCalVW = (px) => (px / 767) * 100;